import PropTypes from "prop-types"
import classnames from "classnames"

import colors from "foundation/_colors_export.scss?export"
import styles from "./complete_icon.module.scss"

export default function CompleteIcon({ color, animate, large }) {

  return (
    <span className={classnames("svg-icon", "svg-icon-checkmark", styles.icon)}>
      <svg
        className={classnames({ [styles["in-circle"]]: large })}
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
      >
        <g
          className={styles.checkmark}
          fill="none"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="6"
        >
          <polyline
            className={classnames(styles["checkmark-check"], { [styles.animate]: animate })}
            stroke={color === "black" ? colors.primaryTextColor : "#FFFFFF"}
            points="2.5 14.5 12 24 29.5 6.5"
          />
        </g>
      </svg>
    </span>
  )
}

CompleteIcon.propTypes = {
  color: PropTypes.oneOf(["black", "white"]),
}

CompleteIcon.defaultProps = {
  color: "black",
  large: false,
}
